module.exports = __webpack_public_path__ + "img/IDQ.351d461e.svg";